import {
  type FC, useCallback, useMemo,
} from 'react';
import { MapTool } from '~/_shared/types/toolsAndFeatures/mapTools.types';
import { useIsDataExportAllowed } from '~/_shared/types/toolsAndFeatures/useIsDataExportAllowed';
import { ModalType } from '~/modal/modalType.enum';
import { useModal } from '~/modal/useModal.hook';
import { useToolCollapseState } from '~/sidebar/sidebarApps/mapTools/useToolCollapseState';
import { useProximityToolSelector } from '~/store/frontendState/proximityTool/proximityTool.selectors';
import { useIsMapEditDisabled } from '~/store/selectors/useMapInfoSelectors';
import { useProximities } from '../useProximities';
import { ProximityPanelComponent } from './proximityPanel.component';

export const ProximityPanelContainer: FC = () => {
  const isEditModeDisabled = useIsMapEditDisabled();
  const isExportAllowed = useIsDataExportAllowed(MapTool.Proximity);
  const proximityList = useProximities();
  const { type: proximityType } = useProximityToolSelector();
  const { openModal: openExportModal } = useModal(ModalType.ExportProximityData);
  const { openModal: openProximitySettingsModal } = useModal(ModalType.ProximitySettings);
  const { isToolCollapsed } = useToolCollapseState();

  const onExportFile = useMemo(() => (
    isExportAllowed ? () => {
      openExportModal({
        selectedProximityIds: [],
        showSelectProximitiesSection: true,
      });
    } : undefined
  ), [isExportAllowed, openExportModal]);

  const onSettingsButtonClick = useCallback(() => {
    openProximitySettingsModal();
  }, [openProximitySettingsModal]);

  return (
    <ProximityPanelComponent
      isLegendMode={isToolCollapsed}
      onExportFile={onExportFile}
      proximityList={proximityList}
      onSettingsButtonClick={onSettingsButtonClick}
      showAdminControls={!isEditModeDisabled}
      proximityType={proximityType}
    />
  );
};
